/**
 * Base interface for validation result.
 */
import {none, Option, some} from "ts-option";

export interface ValidationResult<T> {
	/**
	 * If data are correct and validation pass.
	 */
	readonly isValid: boolean

	/**
	 * Execute a callback on a successful validation.
	 * @param callback the callback.
	 * @return this object.
	 */
	onSuccess(callback: (t: T) => void): ValidationResult<T>

	/**
	 * Execute a callback on a failure validation.
	 * @param callback the callback.
	 * @return this object.
	 */
	onFailure(callback: () => void): ValidationResult<T>

	/**
	 * Get value from result.
	 * @return optional value.
	 */
	getValue():Option<T>
}

/**
 * Successful validation.
 */
export class ValidationSuccessful<T> implements ValidationResult<T> {
	constructor(public readonly value: T) {}

	isValid: boolean = true;

	onSuccess(callback: (t: T) => void): ValidationResult<T> {
		callback(this.value);
		return this;
	}

	onFailure(callback: () => void): ValidationResult<T> {
		return this;
	}

	getValue():Option<T> {
		return some(this.value);
	}
}

/**
 * Failure validation.
 */
export class ValidationFailure<T> implements ValidationResult<T> {
	constructor(public readonly errors: string[]) {}

	isValid: boolean = false;

	onSuccess(callback: (t: T) => void): ValidationResult<T> {
		return this;
	}

	onFailure(callback: () => void): ValidationResult<T> {
		callback();
		return this;
	}

	getValue(): Option<T> {
		return none;
	}
}